import { useCallback, useRef, useState } from "react"
import ReCAPTCHA from "react-google-recaptcha"
import { useForm } from "react-hook-form"
import { toast } from "react-toastify"
import { FormWrapper } from "src/components/form/FormWrapper"
import { FormInput } from "src/components/form/Input/FormInput"
import { FormPhoneInput } from "src/components/form/Input/FormPhoneInput"
import { CountrySelect } from "src/components/form/select/CountrySelect"
import { FormSelect } from "src/components/form/select/FormSelect"
import { Button } from "src/components/ui/button"
import { ChevronRight } from "src/icons"
import { ApiData } from "src/models/ApiData"
import { IOption } from "src/types"
import { MONTHLY_TURNOVER, PRODUCTS } from "../constant"
interface Form {
  first_name: string
  last_name: string
  email: string
  phone: string
  company_name: string
  website: string
  company_country_code: IOption | string
  turnover: IOption
  company_industry: IOption
  agree_terms: boolean
  captcha: string
}
export const IBANSetupForm = () => {
  const [loading, setLoading] = useState(false)
  const captchaRef = useRef(null)
  const formModel = useForm<Form>({
    defaultValues: {
      company_country_code: "GB",
    },
  })
  const control = formModel.control
  const register = formModel.register
  const errors = formModel.formState.errors
  const onSubmit = useCallback(async ({ captcha, ...data }: Form) => {
    setLoading(true)
    try {
      const { success, message } = await ApiData.publicApiRequest(
        {
          ...data,
          company_country_code: typeof data.company_country_code === "string" ? data.company_country_code : data.company_country_code.value,
          turnover: typeof data.turnover === "string" ? data.turnover : data.turnover.value,
          company_industry: typeof data.company_industry === "string" ? data.company_industry : data.company_industry.value,
          "g-recaptcha-response": captcha,
        },
        "send_corp_mail",
      )
      captchaRef.current.reset()

      if (!success) return toast.error(message)
      formModel.reset()
      toast.success("Thank You for Your request!")
    } catch {
    } finally {
      setLoading(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const onCaptchaChange = (value: string) => {
    formModel.setValue("captcha", value, { shouldValidate: true })
  }
  return (
    <div className="setup__form">
      <h1>Setup your business account</h1>
      <FormWrapper methods={formModel} noValidate autoComplete="off" onSubmit={formModel.handleSubmit(onSubmit)}>
        <div className="stack" style={{ marginBottom: 32 }}>
          <FormInput {...{ control, name: "first_name" }} placeholder="First Name" name="first_name" required />
          <FormInput {...{ control, name: "last_name" }} placeholder="Last Name" name="last_name" required />
        </div>
        <FormInput {...{ control, name: "email" }} placeholder="Work Email" name="email" required style={{ marginBottom: 32 }} />
        <FormPhoneInput {...{ control, name: "phone" }} defaultCountry="US" label="Phone Number" style={{ marginBottom: 32 }} />
        <div className="stack" style={{ marginBottom: 32 }}>
          <FormInput {...{ control, name: "company_name" }} placeholder="Company Name" name="company_name" required />
          <FormInput {...{ control, name: "website" }} placeholder="Business Website" name="website" required />
        </div>
        <CountrySelect {...{ control, name: "company_country_code" }} label="Company registration country" />
        <div style={{ margin: "32px 0" }}>
          <FormSelect
            {...{ control, name: "turnover" }}
            options={MONTHLY_TURNOVER}
            label="Monthly turnover range"
            required
            inputProps={{ placeholder: "Select..." }}
          />
        </div>
        <FormSelect
          options={PRODUCTS}
          label="Monthly turnover range"
          name="company_industry"
          control={control}
          required
          inputProps={{ placeholder: "Select..." }}
          style={{ marginBottom: 32 }}
        />

        <div className="step__box_agree" style={{ marginTop: 0 }}>
          <div className="custom-control custom-checkbox">
            <input
              type="checkbox"
              className="custom-control-input"
              id="old"
              defaultChecked={false}
              {...register("agree_terms", { required: true })}
            />
            <label className="custom-control-label" htmlFor="old">
              I Accept <a href="/terms_of_use.html">Terms & Conditions</a> of 7Gates
            </label>
            {errors.agree_terms && <span className="erorrs ml-five">This field is required</span>}
          </div>
        </div>
        <ReCAPTCHA sitekey="6LcK4UIrAAAAAIyxjMXq8Xyf09FzdY2Y2M_zstuc" onChange={onCaptchaChange} />
        <Button rightIcon={<ChevronRight />} loading={loading} style={{ justifyContent: "center", marginTop: 22 }}>
          Send
        </Button>
      </FormWrapper>
    </div>
  )
}
